const EnumTipoRespostaFormulario = Object.freeze({
    MULTIPLA_ESCOLHA: 'MULTIPLA_ESCOLHA',
    DISSERTATIVA: 'DISSERTATIVA',
    TABELA: 'TABELA'
});

export default EnumTipoRespostaFormulario;